import React from 'react';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

const AccCtaSection = () => (
    <section className="lp-acc-sec" id="book">
        <div className="lp-acc-wrap">
            <div className="lp-acc-cta-band" data-lp-reveal>
                <span className="lp-acc-kicker is-onband">Let's talk</span>
                <h2>Let's discuss a formal partnership.</h2>
                <p>Book 30 minutes to walk through the co-origination model, what first-mover advantage looks like for your programme, and what the next steps would involve.</p>
                <div className="ctas">
                    <a className="lp-acc-btn lp-acc-btn--white" href={KOALENDAR} target="_blank" rel="noopener noreferrer">Book a call →</a>
                </div>
            </div>
        </div>
    </section>
);

export default AccCtaSection;
